var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParticipantsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 27,
    viewBox: "0 0 43 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2059 11.5714C32.4073 11.5714 34.9723 8.98714 34.9723 5.78571C34.9723 2.58429 32.4073 0 29.2059 0C26.0045 0 23.4202 2.58429 23.4202 5.78571C23.4202 8.98714 26.0045 11.5714 29.2059 11.5714ZM13.7773 11.5714C16.9788 11.5714 19.5438 8.98714 19.5438 5.78571C19.5438 2.58429 16.9788 0 13.7773 0C10.5759 0 7.99163 2.58429 7.99163 5.78571C7.99163 8.98714 10.5759 11.5714 13.7773 11.5714ZM13.7773 15.4286C9.28377 15.4286 0.277344 17.685 0.277344 22.1786V25.0714C0.277344 26.1321 1.1452 27 2.20592 27H25.3488C26.4095 27 27.2773 26.1321 27.2773 25.0714V22.1786C27.2773 17.685 18.2709 15.4286 13.7773 15.4286ZM29.2059 15.4286C28.6466 15.4286 28.0102 15.4671 27.3352 15.525C27.3738 15.5443 27.3931 15.5829 27.4123 15.6021C29.6109 17.2029 31.1345 19.3436 31.1345 22.1786V25.0714C31.1345 25.7464 30.9995 26.4021 30.7873 27H40.7773C41.8381 27 42.7059 26.1321 42.7059 25.0714V22.1786C42.7059 17.685 33.6995 15.4286 29.2059 15.4286Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParticipantsLogo);
export default __webpack_public_path__ + "static/media/participants-logo.01428587a34be82d8a4e9a8e1e5f3666.svg";
export { ForwardRef as ReactComponent };